
import React, { useMemo } from 'react'
import { Card } from 'react-bootstrap'
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import useTranslation from '@/Hooks/UseTranslation';

interface Props {
  data: any
}

const ProjectSCurve = ({ data }: Props) => {

  const { t } = useTranslation()

  const formatter = (items: any) => {

    const series: any[] = []

    items.map((item: any) => {

      if (item.value) {

        series.push(`<span>${item.seriesName}: ${item.value ? item.value.toFixed(0) : ''}%</span>`)
      }
    })

      return `
        <div>
          ${series.join('<br />')}
        </div>
      `
    }

  const { series, totalWeeks } = useMemo(() => {

    const output: any[] = []

    let baseLine: any[] = []
    let scheduled: any[] = []
    let actual: any[] = []
    let projected: any[] = []

    const weeksNumbers: number[] = []
    let counter = 0

    for (const key in data) {

      const week = data[key]

      baseLine.push(week.baseLineAcc)
      scheduled.push(week.scheduledAcc)

      if (week.actualAcc) {
        actual.push(week.actualAcc)

        if (week.isCurrentWeek) {

          projected.push(week.projectAcc)
        } else {

          projected.push(null)
        }
      } else {
        actual.push(null)
        projected.push(week.projectAcc)
      }

      counter += 1

      weeksNumbers.push(counter)
    }

    // Convertir baseLine a porcentajes (último valor = 100%)
    let maxBaseLine = 0

    baseLine.forEach((value: number) => {

      if (value > maxBaseLine)
        maxBaseLine = value
    })
    if (maxBaseLine > 0) {
      baseLine = baseLine.map(value => value ? Number(((value / maxBaseLine) * 100).toFixed(0)) : '')
    }

    output.push({
      data: baseLine,
      name: t('PROJECT_DASHBOARD:SCurveBaseLineLabel'),
      type: 'line',
      smooth: true,
      lineStyle: {
        normal: {
          color: '#006ebc',
          width: 2,
        }
      },
      itemStyle: {
        color: '#006ebc',
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#006ebc90'
          },
          {
            offset: 1,
            color: '#fff'
          }
        ])
      },
    })

    let maxScheduled = 0

    scheduled.forEach((value: number) => {

      if (value > maxScheduled)
        maxScheduled = value
    })

    if (maxScheduled > 0) {
      scheduled = scheduled.map(value => value ? Number(((value / maxScheduled) * 100).toFixed(0)) : '')
    }

    output.push({
      data: scheduled,
      name: t('PROJECT_DASHBOARD:SCurveScheduledLabel'),
      type: 'line',
      smooth: true,
      lineStyle: {
        normal: {
          color: '#34a854',
          width: 2,
          type: 'dashed'
        }
      },
      itemStyle: {
        color: '#34a854',
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#34a85490'
          },
          {
            offset: 1,
            color: '#fff'
          }
        ])
      },
    })

    // let maxActual = 0

    let maxProjected = 0

    projected.forEach((value: number) => {

      if (value > maxProjected)
        maxProjected = value
    })

    if (maxProjected) {
      actual = actual.map(value => value ? Number(((value / maxProjected) * 100).toFixed(0)) : '')
    }

    output.push({
      data: actual,
      name: t('PROJECT_DASHBOARD:SCurveActualLabel'),
      type: 'line',
      smooth: true,
      lineStyle: {
        normal: {
          color: '#FF6F00',
          width: 2,
        }
      },
      itemStyle: {
        color: '#FF6F00',
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FF6F0090'
          },
          {
            offset: 1,
            color: '#fff'
          }
        ])
      },
    })

    if (maxProjected > 0) {
      projected = projected.map(value => value ? Number(((value / maxProjected) * 100).toFixed(0)) : '')
    }

    output.push({
      data: projected,
      name: t('PROJECT_DASHBOARD:SCurveProjectedLabel'),
      type: 'line',
      smooth: true,
      lineStyle: {
        normal: {
          color: '#f7a464',
          width: 2,
          type: 'dashed'
        }
      },
      itemStyle: {
        color: '#f7a464',
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#f7a46490'
          },
          {
            offset: 1,
            color: '#fff'
          }
        ])
      },
    })

    return { series: output, totalWeeks: weeksNumbers}
  }, [data])

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: true
      },
      formatter
    },
    legend: {
      bottom: 0,
      data: series.map(s => s.name)
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: totalWeeks,
      axisLabel: {
        formatter: "Sem {value}"
      },
    },
    yAxis: {
      axisLabel: {
        formatter: "{value}"
      },
      type: 'value'
    },
    series,
  }

  return (
    <Card>
      <Card.Body>
        <h4 className='card-title'>
          {t('PROJECT_DASHBOARD:SCurveTitle')}
        </h4>
        <ReactEChartsCore
          echarts={echarts}
          option={option}
          style={{ height: '420px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  )
}

export default ProjectSCurve
